import React from 'react';
import styled, { css } from 'styled-components';

import Color from '../../../utils/colors';
import dataPhases from '../consts/dataPhases';
import typograf from '../../../utils/typograf';
import { OpacityReady } from '../consts/other';
import { Font, FontWeight } from '../../../utils/fonts';
import mediaWidth from '../../../utils/mediaWidth/mediaWidth';

import FadeInAnimation from '../../../common/FadeInAnimation/FadeInAnimation';
import { DiscussBtn, RepeatBtn } from './Buttons';
import SubPhaseStages from '../SubPhaseStages';
import PhasesMenu from '../PhasesMenu';

import ArrowLeftIcn from '../assets/arrow-left-gray.svg';
import PriceIcn from '../assets/price-icn.png';

class Phases extends React.PureComponent {
    constructor(props) {
        super(props);
        this.refStages = React.createRef();

        this.handleScroll = this.handleScroll.bind(this);
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll() {
        if (window.innerWidth < 768) {
            const { changeStage, phase, subPhase } = this.props;
            const triggerPosition = window.innerHeight / 2;
            if (this.refStages && this.refStages.current) {
                this.refStages.current.childNodes[0].childNodes.forEach((child, index) => {
                    const rect = child.getBoundingClientRect();
                    if (triggerPosition >= rect.top
                        && triggerPosition <= rect.bottom) {
                        const maxStage = Object.keys(dataPhases[phase].subPhases[subPhase].stages)
                            .length + 1;
                        if (index < maxStage || index + 1 < maxStage) {
                            if (rect.height > 100 && triggerPosition >= rect.top + 100) {
                                changeStage(index + 1);
                            } else {
                                changeStage(index);
                            }
                        }
                    }
                });
            }
        }
    }

    render() {
        const {
            phase, subPhase, stage, isReadyStage,
            changeStage, changePhase,
            changeSubPhase, backToStart,
            showDiscussForm,
        } = this.props;

        const currentPhase = dataPhases[phase];

        return (
            <Container>
                <Desktop isReady={isReadyStage}>
                    <PhasesMenu
                        phase={phase}
                        changePhase={changePhase}
                    />
                </Desktop>
                <Content>
                    <BackButton onClick={backToStart} isReady={isReadyStage}>
                        <img src={ArrowLeftIcn} alt="arrow-left-icn" />
                        этап {phase + 1} из {dataPhases.length}
                    </BackButton>
                    <Title isReady={isReadyStage}>{typograf.execute(currentPhase.name)}</Title>
                    <InfoRow isReady={isReadyStage}>
                        <SubPhasesWrapper>
                            {currentPhase.subPhases.map((sp, index) => (
                                <SubPhase
                                    key={index.toString()}
                                    isActive={subPhase === index}
                                    onClick={() => changeSubPhase(index, true)}
                                >
                                    <div />
                                    <div>{typograf.execute(sp.name)}</div>
                                </SubPhase>
                            ))}
                        </SubPhasesWrapper>
                        <PriceRow>
                            <img src={PriceIcn} alt="price-icn" />
                            {currentPhase.subPhases[subPhase].price.from}
                            <br />
                            {currentPhase.subPhases[subPhase].price.to}
                        </PriceRow>
                    </InfoRow>
                    <SubPhaseStagesStyles
                        isReady={isReadyStage}
                        stage={stage}
                        refContainer={this.refStages}
                        changeStage={changeStage}
                        risks={currentPhase.subPhases[subPhase].risks}
                        items={currentPhase.subPhases[subPhase].stages}
                        results={currentPhase.subPhases[subPhase].results}
                    />
                    <ButtonWrapper>
                        <FadeInAnimation delay="0.5" duration="0.5">
                            <DiscussBtn
                                onClick={showDiscussForm}
                            >
                                Обсудить задачу
                            </DiscussBtn>
                        </FadeInAnimation>
                        <FadeInAnimation delay="0.5" duration="0.5">
                            <RepeatBtn
                                onClick={() => changeSubPhase(subPhase + 1)}
                            >
                                {isReadyStage
                                    ? (subPhase < currentPhase.subPhases.length - 1
                                        ? 'Следующий шаг'
                                        : (phase < dataPhases.length - 1 ? 'следующий этап' : 'что дальше?'))
                                    : 'Далее'}
                            </RepeatBtn>
                        </FadeInAnimation>
                    </ButtonWrapper>
                </Content>
            </Container>
        );
    }
}

const Container = styled.div`
  width: 100%;
  height: 100%;
  background-color: #FFF;
  display: flex;
  overflow-x: hidden;
  
  position: relative;
  
  ${FontWeight.REGULAR};
`;

const SubPhaseStagesStyles = styled(SubPhaseStages)`
  margin-top: 40px;
  ${mediaWidth.m} {
    margin-top: 56px;
  }
  ${mediaWidth.l} {
    margin-top: 32px;
  }
`;

const Desktop = styled.div`
  display: none;
  
  ${({ isReady }) => (isReady ? css`opacity: ${OpacityReady};` : '')}
  
  ${mediaWidth.xl} {
    display: block;
    position: relative;
  }
`;

const Content = styled.div`
  width: 360px;
  margin: 0 auto;
  padding: 132px 16px 40px;
  
  ${mediaWidth.m} {
    width: 100%;
    padding: 152px 48px 166px;
  }
  
  ${mediaWidth.l} {
    padding: 102px 64px 33px;
  }
  
  ${mediaWidth.xl} {
    padding: 96px 63px 101px 56px;
    overflow-x: hidden;
  }
`;

const BackButton = styled.div`
  display: flex;
  align-items: center;

  color: rgba(0, 0, 0, 0.64);
  ${Font.HEADLINE};
  font-size: 14px;
  line-height: 16px;
  text-transform: uppercase;
  cursor: pointer;
  
  ${({ isReady }) => (isReady ? css`opacity: ${OpacityReady};` : '')}

  img {
    margin-right: 14px;
  }
  
  ${mediaWidth.xl} {
    display: none;
  }
`;

const Title = styled.div`
  margin-top: 20px;
  
  ${Font.HEADLINE};
  font-size: 32px;
  line-height: 32px;
  text-transform: uppercase;

  ${({ isReady }) => (isReady ? css`opacity: ${OpacityReady};` : '')}
  
  ${mediaWidth.m} {
    margin-top: 16px;
  }
  
  ${mediaWidth.l} {
    font-size: 30px;
    line-height: 30px;
  }
  
  ${mediaWidth.xl} {
    margin-top: 0;
    font-size: 32px;
    line-height: 32px;
  }
`;

const InfoRow = styled.div`
  margin-top: 48px;
  ${({ isReady }) => (isReady ? css`opacity: ${OpacityReady};` : '')}

  ${mediaWidth.m} {
    margin-top: 56px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  ${mediaWidth.l} {
    margin-top: 32px;
  }

  ${mediaWidth.xl} {
    margin-top: 56px;
  }
`;

const SubPhasesWrapper = styled.div`
  width: 100%;
  display: flex;
  //justify-content: space-between;
  overflow-x: auto;
  
  ${mediaWidth.m} {
    //max-width: 400px;
    margin-right: 50px;
    justify-content: flex-start;
  }
  
  ${mediaWidth.xl} {
    //max-width: 740px;
    //justify-content: flex-start;
  }
`;

const SubPhase = styled.div`
  padding-top: 8px;
  ${({ isActive }) => (isActive ? css`padding-top: 0;` : '')}
  
  cursor: pointer;
  @media (max-width: 767px) {
    align-self: flex-start;
    margin-right: 20px;
    max-width: 110px;
  }
  
  & > div:first-child {
    width: 16px;
    height: 16px;
    border-radius: 100%;
    background-color: rgba(0,0,0,.32);
    ${({ isActive }) => (isActive ? css`width: 24px;height: 24px;background-color: ${Color.SECONDARY};` : '')}
  }
  
  & > div:nth-child(2) {
    margin-top: 16px;
    
    ${Font.PRIMARY};
    font-size: 14px;
    line-height: 18px;
    color: rgba(0,0,0,.32);
    ${({ isActive }) => (isActive ? css`color: ${Color.SECONDARY};` : '')}
  }
  
  ${mediaWidth.m} {
    width: 109px;
    padding-top: 16px;
    ${({ isActive }) => (isActive ? css`padding-top: 0;` : '')}
    
    &:not(:last-child) {
      margin-right: 36px;
    }

    & > div:first-child {
      width: 16px;
      height: 16px;
      ${({ isActive }) => (isActive ? css`
        width: 32px;
        height: 32px;
      ` : '')}
    }
  }
  
  ${mediaWidth.l} {
    &:not(:last-child) {
      margin-right: 46px;
    }
  }
  
  ${mediaWidth.xl} {
    &:not(:last-child) {
      margin-right: 55px;
    }
  }
`;

const PriceRow = styled.div`
  margin-top: 41px;
  
  min-width: 230px;
  display: flex;
  align-items: center;
  
  text-transform: uppercase;
  color: #000;
  ${Font.HEADLINE};
  font-size: 16px;
  line-height: 18px;
  
  img { width: 40px; height: 40px; margin-right: 16px }
  ${mediaWidth.m} { margin-top: 22px; }
`;

const ButtonWrapper = styled.div`
  margin-top: 40px;
  ${mediaWidth.m} {
    margin-top: 50px;
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
  }
  
  ${mediaWidth.l} {
    margin-top: 33px;
    margin-left: auto;
    width: 666px;
  }
  
  ${mediaWidth.xl} {
    margin-top: 50px;
    width: 737px;
  }
`;

export default Phases;
